export default "__VITE_ASSET__CG3V2kLB__"